/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Ex_IntroInputs */

const en_to_csv_ex_intro = /** @type {(inputs: To_Csv_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The second record lacks note and meta, and adds tags. Watch where tags lands in the header.`)
};

const ko_to_csv_ex_intro = /** @type {(inputs: To_Csv_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`두 번째 레코드에는 note와 meta가 없고 tags가 추가되었습니다. tags가 헤더에서 어디에 놓이는지 보세요.`)
};

const ja_to_csv_ex_intro = /** @type {(inputs: To_Csv_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2 件目のレコードには note と meta がなく、tags が加わっています。tags がヘッダのどこに来るかを見てください。`)
};

/**
* | output |
* | --- |
* | "The second record lacks note and meta, and adds tags. Watch where tags lands in the header." |
*
* @param {To_Csv_Ex_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_ex_intro = /** @type {((inputs?: To_Csv_Ex_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Ex_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_ex_intro(inputs)
	if (locale === "ko") return ko_to_csv_ex_intro(inputs)
	return ja_to_csv_ex_intro(inputs)
});